import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=5633b40e&scoped=true&"
import script from "./HeaderNav.vue?vue&type=script&lang=js&"
export * from "./HeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNav.vue?vue&type=style&index=0&id=5633b40e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633b40e",
  null
  
)

export default component.exports